var generateStyle = function generateStyle(componentTheme) {
  return {
    title: {
      margin: "".concat(componentTheme.titleMarginTop, " ").concat(componentTheme.titleMarginLeftRight, " ").concat(componentTheme.titleMarginBottom, " ").concat(componentTheme.titleMarginLeftRight)
    },
    emptyText: {
      padding: componentTheme.emptyTextPadding,
      fontSize: componentTheme.emptyTextFontSize,
      textAlign: 'center',
      color: componentTheme.emptyTextColor
    },
    metric: {
      justifyContent: 'center'
    }
  };
};
export default generateStyle;